import axios from './axios.service';
import { RequestParams } from '@/types/api.types';
import { AxiosRequestConfig } from 'axios';

export default {
    get API_URL() {
        return this.API_DOMAIN;
    },

    get API_DOMAIN() {
        return `${import.meta.env.VUE_APP_API_URL}`;
    },

    /**
     * @deprecated
     * apiService.get accepts service name as a string and returns Promise<any> which is not typesafe
     *
     * Use getResource method from '/lib/api/resource' to achieve typesafety
     */
    get(service: string, params?: RequestParams[], options?: object): Promise<any> {
        return axios.get(this.makeApiEndpoint(service, params), options);
    },

    /**
     * @deprecated
     * This is not typesafe method so it is deprecated.
     * Use postResource method from '/lib/api/resource' to achieve typesafety
     */
    post(service: string, data?: any, params?: RequestParams[], config?: AxiosRequestConfig) {
        return axios.post(this.makeApiEndpoint(service, params), data, config);
    },

    patch(service: string, data?: any, params?: RequestParams[], config?: AxiosRequestConfig) {
        return axios.patch(this.makeApiEndpoint(service, params), data, config);
    },

    delete(service: string, config?: AxiosRequestConfig, params?: RequestParams[]) {
        return axios.delete(this.makeApiEndpoint(service, params), config);
    },

    makeApiEndpoint(service: string, params?: RequestParams[]): string {
        const apiUrl = new URL(`${this.API_DOMAIN}${service}/`);

        if (params) {
            params.forEach((p) => {
                if (Array.isArray(p.value)) {
                    p.value.forEach((v) => apiUrl.searchParams.append(p.key, v.toString()));
                } else {
                    apiUrl.searchParams.append(p.key, p.value.toString());
                }
            });
        }

        return import.meta.env.PROD && import.meta.env.VUE_APP_CONTEXT !== 'deploy-preview' ? apiUrl.pathname + apiUrl.search : apiUrl.href;
    },

    makeApiEndpointWithoutSlash(service: string, params?: RequestParams[]): string {
        const apiUrl = new URL(`${this.API_DOMAIN}${service}`);

        if (params) {
            params.forEach((p) => {
                if (Array.isArray(p.value)) {
                    p.value.forEach((v) => apiUrl.searchParams.append(p.key, v.toString()));
                } else {
                    apiUrl.searchParams.append(p.key, p.value.toString());
                }
            });
        }

        return import.meta.env.PROD && import.meta.env.VUE_APP_CONTEXT !== 'deploy-preview' ? apiUrl.pathname + apiUrl.search : apiUrl.href;
    },

    makeApiFullEndpoint(service: string, params?: RequestParams[]): string {
        const apiUrl = new URL(`${this.API_DOMAIN}${service}/`);
        if (params) {
            params.forEach((p) => {
                if (Array.isArray(p.value)) {
                    p.value.forEach((v) => apiUrl.searchParams.append(p.key, v.toString()));
                } else {
                    apiUrl.searchParams.append(p.key, p.value.toString());
                }
            });
        }
        return apiUrl.href;
    },

    getFileFromURL(url: string, type = 'application/json'): Promise<{ data: File }> {
        return axios.get(url, {
            responseType: 'blob',
            headers: {
                'Content-Type': type,
                Accept: 'application/pdf',
            },
        });
    },
};
